export enum AuthorizationResourceKey {
  SCADA = 'scada',
  TICKETS = 'tickets',
  CALENDAR = 'calendar',
  CONFIGURATION = 'configuration',
  OPEN_TICKETS = 'opentickets',
  ASSIGEND_TICKETS = 'assignedtickets',
  CLOSED_TICKETS = 'closedtickets'
}
